export const STATIC_CONTENT_TYPE = [
  { name: "PRIVACY POLICY", type: 1, id: "69e87a1dde20d6e9a4471cbd" },
  { name: "TERMS AND CONDITIONS", type: 2, id: "69e87a39de20d6e9a4471cc2" },
  { name: "CONTACT US", type: 3, id: "69e87a49de20d6e9a4471cc7" },
  { name: "FAQ", type: 4, id: "69e87a52de20d6e9a4471ccc" },
  // { name: "FAQS", type: 5, id: "5" },
];

export const DIVE_TYPES = {
  Wreck: "wreck",
  Reef: "reef",
  Cave: "cave",
  Ice: "ice",
  Rescue: "rescue",
  Technical: "technical",
  Exploration: "exploration",
};

export const FeedbackStatus = {
  Pending: "1",
  Completed: "4",
};
